import {
  Autocomplete,
  Box,
  Grid,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as FilterIcon } from "../../../src/assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../../src/assets/Customer/FilterIconHover.svg";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import Toast from "../../components/ToastContainer/CustomToast";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import SelfRegistrationCustomPhone from "../OnBoardV2/SelfRegistrationCustomPhone";
import isoCountries from "i18n-iso-countries";
import { getCompanyInfo } from "../../slices/Company/CompanySlice";
import { useDispatch } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function EmployeeFilter(props) {
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [statusOptions, setStatusOptions] = useState([]);
  const [isHovered, setIsHovered] = useState(false);
  const [country, setCountry] = useState("");
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const status = [{ label: "ACTIVE" }, { label: "INACTIVE" }];

  const [payload, setPayload] = useState({
    firstName: "",
    email: "",
    phone: "",
    code: "",
    status: "",
  });

  const handleClose = () => {
    setPayload({
      firstName: "",
      email: "",
      phone: "",
      code: "",
      status: "",
    });
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  const [error, setError] = useState({
    firstName: false,
    email: false,
    phone: false,
    code: false,
    status: false,
  });

  if (open) {
    setDiaLogBoxBlur(true);
  }

  const reset = () => {
    setOpen(false);
  };

  const getCountryCodeFromName = (countryName) => {
    const formattedCountryName = countryName
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
    const countryCode = (
      isoCountries.getAlpha2Code(formattedCountryName, "en") || ""
    ).toLowerCase();
    return countryCode || null;
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });

    setError({
      [name]: false,
    });
  };

  const loadData = () => {
    loadCompany();
    setStatusOptions(status);
  };

  const handlePhoneChange = (value, data, event, formattedValue) => {
    setPayload({
      ...payload,
      phone:
        "+" + data.dialCode + "-" + value.toString().replace(data.dialCode, ""),
    });
  };

  const handleChangeofDropdown = (event) => {
    setPayload({
      ...payload,
      status: event.target.value,
    });
  };

  const loadCompany = () => {
    dispatch(getCompanyInfo())
      .unwrap()
      .then((data) => {
        if ((data.code = "UASI0026")) {
          const fullCountryName = data.data.country;
          const countryCode = getCountryCodeFromName(fullCountryName);
          if (countryCode) {
            setCountry(countryCode);
          }
        }
      })
      .catch((er) => {});
  };
  const handleSubmit = () => {
    if (
      payload.firstName.trim() === "" &&
      payload.code.trim() === "" &&
      payload.email.trim() === "" &&
      payload.phone.trim() === "" &&
      payload.status === ""
    ) {
      Toast(t("COMMON154"), "error");
      return;
    }
    props.applyFilter(payload);
    setPayload({
      firstName: "",
      email: "",
      phone: "",
      code: "",
      status: "",
    });
    handleClose();
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  return (
    <>
      <Tooltip
        title={
          <Typography fontSize={12} fontWeight={500}>
            {t("COMMON006")}
          </Typography>
        }
      >
        <span
          className={darkMode ? "filterdark" : "filter"}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => {
            setOpen(true);
            loadData();
          }}
        >
          {isHovered ? (
            <FilterIconHover
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <EmployeeFilter />
            </FilterIconHover>
          ) : (
            <FilterIcon
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <EmployeeFilter />
            </FilterIcon>
          )}
        </span>
      </Tooltip>

      <DialogBox
        Header={t("COMMON006")}
        acceptText={t("COMMON024")}
        cancelText={t("dataTableCancel")}
        fullWidth={true}
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        cancel={handleClose}
      >
        <Grid
          container
          spacing={1.7}
          justifyContent="center"
          alignItems={"center"}
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "#fff",
            overflow: "auto",
            scrollbarWidth: "none",
          }}
        >
          <Grid item xs={12}>
            <CustomTextfield
              label={t("COMMON020")}
              error={error.firstName}
              name="firstName"
              value={payload.firstName}
              handleChange={(e) => handleChange(e)}
              helperText={error.firstName}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomTextfield
              label={t("COMMON140")}
              error={error.code}
              name="code"
              value={payload.code}
              handleChange={(e) => handleChange(e)}
              helperText={error.code}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomTextfield
              label={t("COMMON042")}
              error={error.email}
              name="email"
              value={payload.email}
              handleChange={(e) => handleChange(e)}
              helperText={error.email}
            />
          </Grid>

          <Grid item xs={12}>
            <Autocomplete
              popupIcon={<ExpandMoreIcon />}
              options={status}
              renderInput={(params) => <TextField {...params} label="Status" />}
              isOptionEqualToValue={(option, value) =>
                (option === null && value === null) ||
                (option && value && option.label === value.label)
              }
              // sx={{ width: '100%' }}
              onChange={(event, newValue) => {
                if (!CommonUtil.isEmptyString(newValue))
                  setPayload({
                    ...payload,
                    status: newValue.label,
                  });
                else {
                  setPayload({
                    ...payload,
                    status: "",
                  });
                }
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <SelfRegistrationCustomPhone
              placeholder={t("COMMON063") + " *"}
              country={country}
              specialLabel={false}
              handleChange={(value, data, event, formattedValue) =>
                handlePhoneChange(value, data, event, formattedValue)
              }
            />
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
